import React from "react"

/**
 * Planetary gateway backdrop — portal rings, distant world, stars (no text).
 * Shared by Profile and Settings.
 */
export default function CosmicGatewayScene({ layerRef }) {
  return (
    <div
      ref={layerRef}
      className="profile-shapes-layer fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      aria-hidden
    >
      <div className="profile-nebula profile-nebula--1" />
      <div className="profile-nebula profile-nebula--2" />

      <div className="profile-stars" />

      <div className="profile-planet-wrap hidden sm:block">
        <div className="profile-planet-atmosphere" />
        <div className="profile-planet-ring" />
        <div className="profile-planet-body" />
        <div className="profile-planet-highlight" />
      </div>

      <div className="profile-gateway">
        <div className="profile-gateway-vortex" />
        <div className="profile-gateway-ring profile-gateway-ring--outer" />
        <div className="profile-gateway-ring profile-gateway-ring--mid" />
        <div className="profile-gateway-ring profile-gateway-ring--inner" />
        <div className="profile-gateway-core" />
      </div>

      <div className="profile-gateway-floor hidden md:block" />
    </div>
  )
}
